export const MARITAL_STATUS = {
  SINGLE: {
    name: "single",
    value: "SINGLE",
  },
  MARRIED: {
    name: "married",
    value: "MARRIED",
  },
  DIVORCED: {
    name: "divorced",
    value: "DIVORCED",
  },
  WIDOWED: {
    name: "widowed",
    value: "WIDOWED",
  },
};

export const GENDER = {
  MASCULINE: {
    name: "masculine",
    value: "MALE",
  },
  FEMENINE: {
    name: "femenine",
    value: "FEMENINE",
  },
  OTHER: {
    name: "other",
    value: "OTHER",
  },
};

export const REFERENCE_RELATION = {
  COWORKER: {
    name: "coworker",
    value: "COWORKER",
  },
  MY_BOSS: {
    name: "my_boss",
    value: "MY_BOSS",
  },
  YOUR_BOSS: {
    name: "your_boss",
    value: "YOUR_BOSS",
  },
};

export const MAX_CONTACT_INFO = 5;

export const PRIVACY_POLICIES_URL =
  "https://www.evaluar.com/politica-de-proteccion-de-datos-evaluar-v1";
